import React from 'react';
import { Box, Icon, IndicatorBar, Review, Typography } from '@drone-js/core';
import { connect } from 'react-redux';
import { StringFormatter } from '@agoda/react-handyman';
import { getReviewTotalAndAverageScore, selectReviewRatingFilters } from 'component/page/detail/Review/ReviewSortAndFilter/ReviewSortAndFilter.utils';
import { mapStateToProps, SortFilterStateProps } from 'component/page/detail/Review/ReviewSortAndFilter/ReviewSortAndFilter.selectors';

const ReviewDistribution: React.FC<SortFilterStateProps> = (props) => {
    const reviewRatingFilters = selectReviewRatingFilters(props.filterMatrix, props.contentLocale, props.cms);
    if (!reviewRatingFilters || reviewRatingFilters.length === 0) {
        return null;
    }

    const { totalReview, averageScore } = getReviewTotalAndAverageScore(reviewRatingFilters);

    /*
    We're using a 3-loop method here because flexbox and the Box component don't work well for aligning 2-dimension data.
    The Box component doesn't support Grid layout. We tried flex-basis and GridItems, but they didn't work.
    Mainly because the word "star" varies in length in different languages.
    With some having very difference in length between singular and plural forms.
     */
    return (
        <>
            <Box display="flex" flexDirection="column" mb="12">
                <Box data-testid="activities-review-distribution-summary" display="flex" flexDirection="row" alignItems="center">
                    <Icon id="fill.symbol.star" color="product.rating-hotels" me="4" size="16" />
                    <Review
                        score={averageScore}
                        description={StringFormatter.format(props.cms[101866], totalReview.toLocaleString(props.contentLocale))}
                        size="l"
                        color="secondary"
                    />
                </Box>
            </Box>
            <Box display="flex" maxWidth="400px" flexDirection="row" data-testid="activities-review-distribution-indicator-container">
                <Box display="flex" flexDirection="column" alignItems="end" justifyContent="space-around">
                    {reviewRatingFilters.map((review, index) => (
                        <Typography key={index} variant="caption-default-strong" textColor="base.default" py="4" display="flex">
                            {review.label}
                        </Typography>
                    ))}
                </Box>
                <Box flexGrow={1} flexDirection="column" display="flex" justifyContent="space-around" px="8">
                    {reviewRatingFilters.map((review, index) => (
                        <Box key={index} display="flex" alignItems="center" py="4">
                            <IndicatorBar
                                intent="generic"
                                size="s"
                                value={review.count}
                                maxValue={totalReview}
                                label={review.label}
                                data-testid="activities-review-distribution-indicator-bar"
                            />
                        </Box>
                    ))}
                </Box>
                <div>
                    {reviewRatingFilters.map((review, index) => (
                        <Typography key={index} variant="caption-default" textColor="base.subtle" py="4" display="flex">
                            {review.count.toLocaleString(props.contentLocale)}
                        </Typography>
                    ))}
                </div>
            </Box>
        </>
    );
};

ReviewDistribution.displayName = 'ReviewDistribution';
export default connect(mapStateToProps)(ReviewDistribution);
